module.exports = __webpack_public_path__ + "img/1-2.c0b725f2.svg";